import { FEATURE_FLAGS } from '../../../../featureFlags';

/**
 * Label-like records managed on the unified Labels settings screen. Every
 * type shares the same form (title, description, color, show on sidebar) and
 * only differs on its Vuex module, i18n namespace and feature flag.
 *
 * `featureFlag` is optional: types without it are always available, the ones
 * with it are only shown when the flag is enabled on the current account.
 */
export const LABEL_TYPES = [
  {
    key: 'labels',
    i18nPrefix: 'LABEL_MGMT',
    storeModule: 'labels',
    recordsGetter: 'getLabels',
    icon: 'tag',
  },
  {
    key: 'products',
    i18nPrefix: 'PRODUCT_MGMT',
    storeModule: 'productLabels',
    recordsGetter: 'getProductLabels',
    icon: 'box-label',
    featureFlag: FEATURE_FLAGS.PRODUCT_LABELS_LIST,
  },
  {
    key: 'topics',
    i18nPrefix: 'TOPIC_MGMT',
    storeModule: 'topicLabels',
    recordsGetter: 'getTopicLabels',
    icon: 'topic',
    featureFlag: FEATURE_FLAGS.TOPIC_LABELS_LIST,
  },
  {
    key: 'concurrents',
    i18nPrefix: 'CONCURRENT_MGMT',
    storeModule: 'concurrentLabels',
    recordsGetter: 'getConcurrentLabels',
    icon: 'concurrent',
    featureFlag: FEATURE_FLAGS.CONCURRENT_LABELS_LIST,
  },
];

export const DEFAULT_LABEL_TYPE = LABEL_TYPES[0].key;

export const findLabelType = key =>
  LABEL_TYPES.find(type => type.key === key) || LABEL_TYPES[0];

export const getAvailableLabelTypes = (isFeatureEnabled = () => false) =>
  LABEL_TYPES.filter(
    type => !type.featureFlag || isFeatureEnabled(type.featureFlag)
  );
